import { callApi, ThrowError } from '@/api/callApi';
import { API_ENDPOINT, API_URL_CMS_SERVICE } from '@/api/constant';
import AppLayoutOrder from '@/components/appLayout/AppLayoutOrder';
import AppLayoutTable from '@/components/appLayout/AppLayoutTable';
import PageHeading from '@/components/common/PageHeading';
import Layout from '@/components/Layout/Layout';
import { IAppLayout } from '@/interfaces/appLayout.interface';
import { useEffect, useState, useTransition } from 'react';

const includedKeys = ['categories', 'bundles', 'bestSellers', 'todaysChoices'];

const AppLayout = () => {
  const [showTable, setShowTable] = useState(true);
  const [isPending, startTransition] = useTransition();

  const [data, setData] = useState<IAppLayout[]>([]);

  const fetchLayout = () => {
    try {
      startTransition(async () => {
        const PATH = `${API_URL_CMS_SERVICE}${API_ENDPOINT.homeLayout}`;
        const res = await callApi<IAppLayout[]>(PATH, { method: 'GET' });
        const filtered = res.filter((i) => includedKeys.includes(i.key));
        setData(filtered);
      });
    } catch (error) {
      ThrowError(error);
    }
  };
  useEffect(() => {
    fetchLayout();
  }, []);
  return (
    <Layout>
      <PageHeading
        text="App Layout"
        button={{
          text: showTable ? 'Re-Order Layout' : 'Cancel',
          onClick: () => setShowTable((prev) => !prev),
        }}
      />

      {showTable ? (
        <AppLayoutTable
          data={data}
          isLoading={isPending}
          onSuccess={() => fetchLayout()}
        />
      ) : (
        <AppLayoutOrder
          data={data}
          isLoading={isPending}
          onSuccess={() => {
            fetchLayout();
            setShowTable(true);
          }}
        />
      )}
    </Layout>
  );
};

export default AppLayout;
